import { z } from 'zod';
/**
 * Token spend on a patient order's clinical questions, totalled per prediction model. `modelName`
 * is null for questions answered before primary began recording which model ran.
 */
export const ClinicalQuestionTokenUsageSchema = z.object({
    modelName: z.string().nullable(),
    inputTokens: z.number(),
    cachedInputTokens: z.number(),
    outputTokens: z.number(),
});
/** Query params for `GET /flow/data-access/clinical-questions/token-usage`. */
export const ClinicalQuestionTokenUsageQuerySchema = z
    .object({
    patientOrderId: z.uuid(),
})
    .strict();
//# sourceMappingURL=tokenUsage.js.map